import { APIClient } from "@merpay/api-client";
import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import options from "#build/api-client-config.mjs";
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const baseURL = config.API_BASE_URL || config.public.API_BASE_URL || options.baseURL;
  const browserBaseURL = config.public.API_BROWSER_BASE_URL || options.browserBaseURL || baseURL;
  let timeoutDuration = config.public.API_TIMEOUT_DURATION || options.timeoutDuration;
  if (process.server && !baseURL) {
    throw new Error("[@merpay/nuxt-api-client] API base URL not defined.");
  }
  if (process.client && !browserBaseURL) {
    throw new Error(
      "[@merpay/nuxt-api-client] Client-side API base URL not defined."
    );
  }
  if (typeof timeoutDuration === "string") {
    timeoutDuration = parseInt(timeoutDuration, 10);
  }
  const apiClient = APIClient.initWithOptions({
    baseURL: process.client ? browserBaseURL : baseURL,
    timeoutDuration
  });
  return {
    provide: {
      apiClient
    }
  };
});
